import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
import { CheckCircleIcon, DownloadIcon, PlayCircleIcon } from 'lucide-react';
export const CallToAction = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-108">
      <div className="w-full mb-6" data-id="element-109">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bvzcazpXKQq4EgnibKd6D6/freepik__the-style-is-candid-image-photography-with-natural__77414.png" alt="Vergelijking: vrouw met hond gevangen in huis versus vrouw die vrij naar buiten kan gaan terwijl hond ontspannen blijft" className="w-full h-auto rounded-lg shadow-md hover:opacity-95 transition-opacity cursor-pointer" onClick={openModal} data-id="element-110" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-111">
          Van gevangen naar vrij - in slechts 3 maanden
        </p>
      </div>
      <div className="bg-red-50 p-3 rounded-lg mb-6 border-2 border-red-300" data-id="element-112">
        <p className="text-center font-bold text-red-700" data-id="element-113">
          ⚠️ NOG SLECHTS 7 PLEKKEN BESCHIKBAAR DEZE MAAND ⚠️
        </p>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-8 border border-blue-200 hover:bg-blue-100 transition-colors" data-id="element-114">
        <h2 className="text-xl font-bold text-blue-800 mb-4 text-center" data-id="element-115">
          Start met je gratis intake gesprek
        </h2>
        <div className="flex flex-col md:flex-row justify-between items-center mb-6" data-id="element-116">
          <div className="mb-4 md:mb-0" data-id="element-117">
            <h3 className="text-lg font-bold" data-id="element-118">
              45-60 minuten uitgebreid gesprek
            </h3>
            <p className="text-gray-600" data-id="element-119">
              Ontdek de echte oorzaak van het probleem
            </p>
          </div>
          <div className="text-right" data-id="element-120">
            <span className="text-2xl font-bold text-blue-800" data-id="element-121">GRATIS</span>
            <p className="text-sm text-green-600" data-id="element-122">Normaal €85</p>
          </div>
        </div>
        <ul className="space-y-3 mb-6" data-id="element-123">
          <li className="flex items-start" data-id="element-124">
            <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-125" />
            <span data-id="element-126">Duidelijkheid over wat er echt aan de hand is</span>
          </li>
          <li className="flex items-start" data-id="element-127">
            <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-128" />
            <span data-id="element-129">Inzicht of en hoe wij je kunnen helpen</span>
          </li>
          <li className="flex items-start" data-id="element-130">
            <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-131" />
            <span data-id="element-132">Een concreet plan van aanpak</span>
          </li>
          <li className="flex items-start" data-id="element-133">
            <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-134" />
            <span data-id="element-135">Geen verplichtingen - alleen duidelijkheid</span>
          </li>
        </ul>
        <p className="mb-4 text-center text-sm text-gray-600" data-id="element-136">
          <strong data-id="element-137">Waarom gratis?</strong> Omdat we alleen met mensen willen
          werken die we écht kunnen helpen. Tijdens het intake gesprek bepalen
          we samen of dat het geval is.
        </p>
        <a href="https://training.stresslessdogs.nl/va-video" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 mb-4 animate-pulse block text-center" data-id="element-138">
          JA, IK WIL MIJN GRATIS INTAKE GESPREK - NU AANMELDEN
        </a>
        <div className="flex justify-center space-x-2" data-id="element-139">
          <span className="text-yellow-500" data-id="element-140">★★★★★</span>
          <span className="text-sm text-gray-600" data-id="element-141">
            Gebaseerd op 628 reviews (4.9/5)
          </span>
        </div>
      </div>
      <div className="bg-gray-50 p-5 rounded-lg mb-6 flex items-center" data-id="element-142">
        <PlayCircleIcon className="w-10 h-10 text-blue-500 mr-4 flex-shrink-0" data-id="element-143" />
        <div data-id="element-144">
          <h3 className="font-bold mb-1" data-id="element-145">Bekijk onze uitleg video</h3>
          <p className="text-sm" data-id="element-146">
            Bekijk onze uitleg video "Hoe je verlatingsangst aanpakt" door
            Stressless Dogs. In 15 minuten leg ik precies uit waarom
            traditionele methoden falen en hoe onze aanpak anders is.
          </p>
          <a href="https://training.stresslessdogs.nl/va-video" className="mt-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200 text-sm inline-block" data-id="element-147">
            BEKIJK DE GRATIS UITLEG VIDEO
          </a>
        </div>
      </div>
    </section>;
};